import {
    PlannedWorkShiftDto,
    PlannedWorkShiftQueryParameters,
} from "../models/plannedWorkShift/plannedWorkShift";
import { apiCall } from "./apiClient";

export const getPlannedWorkShifts = async(
    params: PlannedWorkShiftQueryParameters,
    signal?: AbortSignal
) => {
    const response = await apiCall<
        PlannedWorkShiftDto[],
        PlannedWorkShiftQueryParameters
    >("PlannedWorkShifts/published", "GET", params, signal);
    return response.data;
};
